export const Capitalize = (word) =>  word.charAt(0).toUpperCase() + word.slice(1);